import React from "react";

const problemCards = [
  {
    icon: "🔗",
    iconAlt: "unified data mesh",
    title: "Unified Data Mesh",
    description:
      "Seamless real-time integration across Bloomberg, Refinitiv and alternative data sources.",
  },
  {
    icon: "🤖",
    iconAlt: "autonomous AI agents",
    title: "Autonomous AI Agents",
    description:
      "Self-learning agents that discover, clean and structure data based on your unique requirements.",
  },
  {
    icon: "⚡",
    iconAlt: "real-time processing",
    title: "Real-time Processing",
    description:
      "Millisecond data feeds with automated quality assurance and anomaly detection.",
  },
  {
    icon: "🌳",
    iconAlt: "logic trees",
    title: "Logic Trees",
    description:
      "Ensure clarity with traceable data points in Rose AI, preserving the integrity of every insight.",
  },
  {
    icon: "🤝",
    iconAlt: "seamless collaboration",
    title: "Seamless Collaboration",
    description:
      "Foster innovation by sharing workspaces, allowing team contributions while maintaining data integrity and security.",
  },
  {
    icon: "🗣️",
    iconAlt: "natural language AI",
    title: "Natural Language AI",
    description:
      "Query complex datasets using plain English, powered by our proprietary financial knowledge bank.",
  },
];

const TheProblemSection = () => {
  return (
    <div
      style={{
        background: 'url("/static/img/banner-background.png")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="pt-20 md:py-36 lg:py-[80px] px-5 md:px-20 xl:px-28 flex flex-col items-center gap-10 lg:gap-0"
    >
      <div className="flex flex-col items-center">
        <div className="text-white text-[28px] sm:text-[34px] md:text-[48px] lg:text-[60px] xl:text-[72px] text-center font-bold mb-5 mt-2">
          Working with Data is Hard, Especially in Finance.
        </div>
        <div className="text-white text-[16px] md:text-[20px] lg:text-[22px] xl:text-[24px] mt-4  max-w-5xl flex text-center">
          The necessity for a unified platform that simplifies data discovery,
          visualization, and analysis while preserving data integrity is more
          critical than ever.
        </div>

        <div className="px-0 md:px-10 py-0 md:py-5">
          <img
            src="/static/img/the-problem-content-data-map.png"
            alt="the problem"
            className="w-full h-auto object-contain"
            style={{
              maskImage:
                "linear-gradient(to bottom, transparent, black 45%, black 85%, transparent)",
              WebkitMaskImage:
                "linear-gradient(to bottom, transparent, black 35%, black 75%, transparent)",
            }}
          />
        </div>
        <div className="text-white text-[16px] md:text-[20px] lg:text-[22px] xl:text-[24px] relative max-w-5xl text-center">
          Our agentic data platform has 50+ million time series data from 30+
          vendors ready to go out of the box, with the ability to seamlessly
          integrate with other public and private datasets
        </div>
      </div>

      <div className="w-full flex items-center justify-center pt-0 md:pt-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-5 max-w-4xl lg:max-w-6xl">
          {problemCards.map((card, index) => (
            <div
              key={index}
              className="bg-[rgba(12,15,20,0.8)] backdrop-blur-md rounded-xl p-3 md:p-5 md:py-10 border border-[rgba(255,255,255,0.05)]"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl">{card.icon}</span>
                <div className="text-white text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px]">
                  {card.title}
                </div>
              </div>
              <div className="text-white text-[16px] md:text-[18px] lg:text-[20px] xl:text-[22px] pl-2 font-medium">
                {card.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TheProblemSection;
